<div class="container-fluid py-3">
  <div class="row">

      <div class="col-12">

          <p-table #dt
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
              [filterDelay]="0"
              [loading]="notificationTypeService.loading"
              [paginator]="true"
              [rows]="10"
              [rowHover]="true"
              [rowsPerPageOptions]="[10,25,50]"
              [showCurrentPageReport]="true" 
              [value]="notificationTypeService.notificationTypes"
              pDroppable="row">
              <ng-template pTemplate="caption">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-4 d-flex align-items-center">
                      Tipos de notificaciones
                    </div>

                    <div class="col-8 text-end">
                      <button
                        (click)="open()"
                        class="btn btn-success rounded-circle me-2">
                        <i class="material-icons mt-1">add</i>
                      </button>

                      <button
                        (click)="notificationTypeService.getAll()"
                        class="btn btn-primary rounded-circle me-2">
                        <i class="material-icons mt-1">refresh</i>
                      </button>

                      <button
                        class="btn btn-light rounded-circle me-2">
                        <i class="material-icons mt-1">filter_alt_off</i>
                      </button>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template pTemplate="header">
                  <tr>

                    <th></th>

                    <th pSortableColumn="notificationTypeId">
                      ID
                      <p-sortIcon field="notificationTypeId"></p-sortIcon>
                      <p-columnFilter type="text" field="notificationTypeId" display="menu"></p-columnFilter>
                    </th>

                    <th pSortableColumn="code">
                      Código
                      <p-sortIcon field="code"></p-sortIcon>
                      <p-columnFilter type="text" field="code" display="menu"></p-columnFilter>
                    </th>

                    <th pSortableColumn="notificationType">
                      Nombre
                      <p-sortIcon field="notificationType"></p-sortIcon>
                      <p-columnFilter type="text" field="notificationType" display="menu"></p-columnFilter>
                    </th>

                    <th></th>
                  </tr>
              </ng-template>
              <ng-template pTemplate="body" let-notificationType let-rowIndex="rowIndex">
                  <tr class="p-selectable-row">

                    <td>
                      @if(notificationType.image) {
                        <div 
                          class="bg-center"
                          style="width: 5vh; height: 5vh;"
                          [ngStyle]="{
                            'background-image': 'url(' + notificationType.image.urlFile + ')'
                          }">
                        </div>
                      }
                    </td>

                    <td>
                      <span class="p-column-title">ID</span>
                      {{notificationType.notificationTypeId}}
                    </td>

                    <td>
                      <span class="p-column-title">Código</span>
                      {{notificationType.code}}
                    </td>

                    <td>
                      <span class="p-column-title">Nombre</span>
                      {{notificationType.notificationType}}
                    </td>

                    <td>

                      <button
                        (click)="open(notificationType)"
                        class="btn btn-sm btn-light rounded-circle me-2 my-1">
                        <i class="material-icons mt-1">edit</i>
                      </button>

                      <button
                        class="btn btn-sm btn-danger rounded-circle me-2 my-1">
                        <i class="material-icons mt-1">delete</i>
                      </button>
                    </td>
                  </tr>
              </ng-template>
          </p-table>

      </div>

  </div>
</div>